/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_Gbp3Inputs */

const he_currency_gbp3 = /** @type {(inputs: Currency_Gbp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GBP - British Pound`)
};

const en_currency_gbp3 = /** @type {(inputs: Currency_Gbp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GBP - British Pound`)
};

/**
* | output |
* | --- |
* | "GBP - British Pound" |
*
* @param {Currency_Gbp3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const currency_gbp3 = /** @type {((inputs?: Currency_Gbp3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_Gbp3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_currency_gbp3(inputs)
	return en_currency_gbp3(inputs)
});
export { currency_gbp3 as "currency_GBP" }